module.exports = __webpack_public_path__ + "prod/1.42.2/img/hybrid-cloud-one.779c5351.png";